export default __webpack_public_path__ + "static/media/file-check-white-alt.1f087053.svg";